/// <reference types="vite-plugin-svgr/client" />
import { useState } from 'react'
import { Menu, UnstyledButton } from '@mantine/core'

import type { MoreDropdownProps } from '@/components/MoreDropdown/MoreDropdown.types'

import MoreIcon from '@/assets/icons/more.svg?react'

import classes from './MoreDropdown.module.css'

export function MoreDropdown({ items, ...props }: MoreDropdownProps) {
  const [opened, setOpened] = useState(false)

  return (
    <Menu
      {...props}
      onChange={setOpened}
      opened={opened}
      position="bottom-start"
      radius={8}
    >
      <Menu.Target>
        <UnstyledButton className={classes.moreDropdown}>
          <MoreIcon />
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown>
        {items.map(item => (
          <Menu.Item
            key={item.label}
            onClick={() => item.onClick && item.onClick(item.param)}
          >
            {item.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}
